import gql from 'graphql-tag';

export const GET_ADMISSION_FILTERS = gql`
  query getAdmissionFilters($IDSchool: Int!, $filter: EnquiryFilter) {
    getAdmissionFilters(IDSchool: $IDSchool, filter: $filter) {
      stages {
        code
        name
        statuses {
          code
          name
        }
      }
    }
  }
`;

export const GET_REGISTRATIONS_FRONTEND_STATES = gql`
  query {
    getRegistrationFrontendStates
  }
`;

export const GET_REGISTRATIONS = gql`
  query getRegistrations(
    $statuses: [String!]
    $searchString: String
    $createdFrom: Datetime
    $createdTo: Datetime
    $enrollmentDateFrom: Datetime
    $enrollmentDateTo: Datetime
    $pagination: Pagination
    $centres: [Int!]
    $levels: [Int!]
    $programs: [Int!]
    $filter: RegistrationFilter
  ) {
    getRegistrations(
      filter: $filter
      statuses: $statuses
      searchString: $searchString
      createdFrom: $createdFrom
      createdTo: $createdTo
      enrollmentDateFrom: $enrollmentDateFrom
      enrollmentDateTo: $enrollmentDateTo
      pagination: $pagination
      IDCentres: $centres
      IDLevels: $levels
      IDPrograms: $programs
    ) {
      totalCount
      data {
        ID
        currentFrontendStatus
        state
        createdAt
        updatedAt
        registrationChildMappings {
          data {
            ID
            # enrollmentPlan
            enrolmentDate
            registrationChild {
              ID
              fkChild
              lastname
              firstname
              birthCertificate
              dateOfBirth
              imageKey
              imageKeyPresignedURL
              mainApplicant {
                identificationNo
                firstname
                lastname
                email
                mobilePhone
                mobilePhoneCountryCode
              }
              registrationChildParents(filter: { type: "applicant" }) {
                data {
                  ID
                  registrationParent {
                    firstname
                    lastname
                    mobilePhoneCountryCode
                    mobilePhone
                    email
                  }
                }
              }
            }
            centre {
              code
              label
            }
            level {
              label
            }
            program {
              label
            }
          }
        }
      }
    }
  }
`;

export const SEARCH_ADMISSIONS = gql`
  query searchAdmissions(
    $q: String!
    $filter: EnquiryFilter
    $pagination: Pagination
  ) {
    searchAdmissions(q: $q, filter: $filter, pagination: $pagination) {
      totalCount
      data {
        child {
          ID
          firstname
          lastname
          birthCertificate
        }
        user {
          ID
          firstname
          lastname
          mobilePhoneCountryCode
          mobilePhone
          email
        }
      }
    }
  }
`;

export const SUGGESTED_FEE_TIER = gql`
  query getSuggestedFeeTierForRegistrationChild(
    $registrationID: Int!
    $registrationChildID: Int!
    $enrolmentDate: Datetime!
  ) {
    getSuggestedFeeTierForRegistrationChild(
      registrationID: $registrationID
      registrationChildID: $registrationChildID
      enrolmentDate: $enrolmentDate
    ) {
      data {
        ID
        label
      }
    }
  }
`;

export const FIND_ALL_ADMISSION = gql`
  query findAllAdmission(
    $IDSchool: Int!
    $stageCode: String
    $statusCode: String
    $filter: EnquiryFilter
    $pagination: Pagination
  ) {
    findAllAdmission(
      IDSchool: $IDSchool
      stageCode: $stageCode
      statusCode: $statusCode
      filter: $filter
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        firstname
        lastname
        childFirstname
        pendingRegisterSince
        source
        createdAt
        updatedAt
        fkEnquiryState
        centre {
          code
          label
        }
        level {
          label
        }
        program {
          label
        }
        enrollmentPlan
        child {
          ID
          firstname
          lastname
          birthCertificate
          dateOfBirth
        }
        user {
          firstname
          lastname
          mobilePhoneCountryCode
          mobilePhone
          email
        }
        admissionStatus {
          ID
          label
        }
      }
    }
  }
`;

export const GET_EXISTING_PARENT = gql`
  query getExistingParent($nric: String, $email: String!) {
    getExistingParent(nric: $nric, email: $email) {
      parent {
        ID
        lastname
        firstname
        email
        mobilePhoneCountryCode
        mobilePhone
        workplaceStaff
        gender
        identificationNo
        nationality
        race
        monthlyIncome
        highestQualification
        maritalStatus
        birthdate
        isEmployed
        relation
        workingStatus
        occupationalTitle
      }
      regParent {
        ID
        lastname
        firstname
        email
        mobilePhoneCountryCode
        mobilePhone
        workplaceStaff
      }
    }
  }
`;

export const GET_ECDA_EXISTING_PARENT = gql`
  query getECDAExistingParent($email: String!) {
    getECDAExistingParent(email: $email) {
      parent {
        ID
        lastname
        firstname
        email
        mobilePhoneCountryCode
        mobilePhone
        workplaceStaff
        gender
        identificationNo
        nationality
        race
        monthlyIncome
        highestQualification
        maritalStatus
        birthdate
        isEmployed
        relation
        workingStatus
        occupationalTitle
      }
      ecdaRegParent {
        ID
        fullname
        email
        mobilePhoneCountryCode
        mobilePhone
        workplaceStaff
      }
    }
  }
`;

export const GET_EXISTING_PARENT_INFO = gql`
  query getParent($parentFilter: ParentFilter!, $childId: FilterOnField) {
    getParent(parentFilter: $parentFilter) {
      data {
        ID
        userByFkUser(filter: { active: [0, 1] }) {
          ID
        }
        childRelations(filter: { fkChild: $childId, active: [0, 1] }) {
          data {
            fkRelation
            fkChild
          }
        }
        lastname
        firstname
        email
        mobilePhoneCountryCode
        mobilePhone
        workplaceStaff
        gender
        identificationNo
        nationality
        race
        monthlyIncome
        highestQualification
        maritalStatus
        birthdate
        isEmployed
        relation
        workingStatus
        occupationalTitle
      }
    }
  }
`;

export const GET_EXISTING_CHILD = gql`
  query getExistingChildV2(
    $birthCertificate: String!
    $dateOfBirth: Datetime!
  ) {
    getExistingChildV2(
      birthCertificate: $birthCertificate
      dateOfBirth: $dateOfBirth
    ) {
      child {
        ID
        firstname
        lastname
        birthCertificate
        dateOfBirth
        childRelations(filter: { type: "applicant" }) {
          data {
            ID
            type
            fkRelation
          }
        }
      }
      mainApplicant {
        ID
        firstname
        lastname
        email
        mobilePhoneCountryCode
        mobilePhone
        workplaceStaff
        identificationNo
      }
      regParent {
        ID
        firstname
        lastname
        email
        mobilePhoneCountryCode
        mobilePhone
        workplaceStaff
        identificationNo
      }
      regChild {
        ID
        firstname
        lastname
        birthCertificate
        dateOfBirth
        registrationChildParents(filter: { type: "applicant" }) {
          data {
            fkRelationship
          }
        }
      }
    }
  }
`;

export const GET_ECDA_EXISTING_CHILD = gql`
  query getECDAExistingChild(
    $birthCertificate: String!
    $dateOfBirth: Datetime!
  ) {
    getECDAExistingChild(
      birthCertificate: $birthCertificate
      dateOfBirth: $dateOfBirth
    ) {
      child {
        ID
        firstname
        lastname
        birthCertificate
        dateOfBirth
        childRelations(filter: { type: "applicant" }) {
          data {
            ID
            type
            fkRelation
          }
        }
      }
      mainApplicant {
        ID
        firstname
        lastname
        email
        mobilePhoneCountryCode
        mobilePhone
        workplaceStaff
        identificationNo
      }
      ecdaRegParent {
        ID
        email
        mobilePhoneCountryCode
        mobilePhone
        workplaceStaff
        identificationNo
        fullname
      }
      ecdaRegChild {
        ID
        fullname
        birthCertificate
        dateOfBirth
        ecdaRegistrationChildParents(filter: { type: "applicant" }) {
          data {
            fkRelationship
          }
        }
      }
    }
  }
`;

export const CREATE_REGISTRATION = gql`
  mutation createRegistration(
    $newRegistration: RegistrationDto!
    $bypassExceeding: Boolean
  ) {
    createRegistration(
      newRegistration: $newRegistration
      bypassExceeding: $bypassExceeding
    ) {
      ID
      registrationChildMappings {
        data {
          fkRegistrationChild
        }
      }
    }
  }
`;
export const CREATE_REGISTRATION_ECDA_MVP = gql`
  mutation createNewECDARegistration(
    $newRegistration: RegistrationDto!
    $bypassExceeding: Boolean
  ) {
    createNewECDARegistration(
      newRegistration: $newRegistration
      bypassExceeding: $bypassExceeding
    ) {
      ID
      fkEcdaRegistrationChild
    }
  }
`;

export const EDIT_REGISTRATION = gql`
  mutation editRegistration(
    $enquiryID: Int!
    $editRegistration: RegistrationDto!
    $remarks: String
    $bypassExceeding: Boolean
  ) {
    editRegistration(
      IDRegistration: $enquiryID
      editRegistration: $editRegistration
      remarks: $remarks
      bypassExceeding: $bypassExceeding
    ) {
      ID
      registrationChildMappings {
        data {
          fkRegistrationChild
        }
      }
    }
  }
`;

export const EDIT_REGISTRATION_ECDAMVP = gql`
  mutation editECDARegistration(
    $IDRegistration: Int!
    $editRegistration: RegistrationDto!
    $remarks: String
    $bypassExceeding: Boolean
  ) {
    editECDARegistration(
      IDRegistration: $IDRegistration
      editRegistration: $editRegistration
      remarks: $remarks
      bypassExceeding: $bypassExceeding
    ) {
      ID
      fkEcdaRegistrationChild
    }
  }
`;

export const MERGE_REGISTRATION_PARENT_EMAIL = gql`
  mutation mergerRegistrationParentEmail(
    $notSelectedEmail: String!
    $selectedEmail: String!
  ) {
    mergerRegistrationParentEmail(
      notSelectedEmail: $notSelectedEmail
      selectedEmail: $selectedEmail
    )
  }
`;

export const MERGE_PARENT_ACCOUNT = gql`
  mutation updateParentDuplicateEmail(
    $parentID: Int!
    $notSelectedEmail: String!
    $selectedEmail: String!
  ) {
    updateParentDuplicateEmail(
      parentID: $parentID
      notSelectedEmail: $notSelectedEmail
      selectedEmail: $selectedEmail
    ) {
      ID
      email
      mobilePhone
      mobilePhoneCountryCode
    }
  }
`;

export const CANCEL_REGISTRATION = gql`
  mutation cancelRegistration(
    $enquiryID: Int!
    $isReapplication: Boolean!
    $remarks: String
    $cancellationReason: Int!
    $bypassExceeding: Boolean
  ) {
    cancelRegistration(
      IDRegistration: $enquiryID
      isReapplication: $isReapplication
      remarks: $remarks
      IDCancellationReason: $cancellationReason
      BypassExceeding: $bypassExceeding
    ) {
      ID
    }
  }
`;

export const REINSTATE_CANCELLED_REGISTRATION = gql`
  mutation reinstateCancelledRegistration(
    $registrationID: Int!
    $remarks: String
  ) {
    reinstateCancelledRegistration(
      IDRegistration: $registrationID
      remarks: $remarks
    )
  }
`;

export const GET_ECDA_REGISTRATIONS = gql`
  query getECDARegistrations(
    $statuses: [String!]
    $searchString: String
    $createdFrom: Datetime
    $createdTo: Datetime
    $enrollmentDateFrom: Datetime
    $enrollmentDateTo: Datetime
    $pagination: Pagination
    $IDCentres: [Int!]
    $IDLevels: [Int!]
    $IDPrograms: [Int!]
    $filter: EcdaRegistrationFilter
  ) {
    getECDARegistrations(
      filter: $filter
      statuses: $statuses
      searchString: $searchString
      createdFrom: $createdFrom
      createdTo: $createdTo
      enrollmentDateFrom: $enrollmentDateFrom
      enrollmentDateTo: $enrollmentDateTo
      pagination: $pagination
      IDCentres: $IDCentres
      IDLevels: $IDLevels
      IDPrograms: $IDPrograms
    ) {
      totalCount
      data {
        ID
        state
        createdAt
        updatedAt
        documentStatus
        paymentStatus
        giroStatus
        state
        enrolmentDate
        enquiryDate
        currentFrontendStatus
        previousFrontendStatus
        ecdaRegistrationChild {
          ID
          fkChild
          fullname
          birthCertificate
          dateOfBirth
          imageKey
          mainApplicant {
            fkUser
            identificationNo
            fullname
            email
            mobilePhone
            mobilePhoneCountryCode
          }
        }
        ecdaRegistrationParent {
          ID
          fullname
          mobilePhoneCountryCode
          mobilePhone
          email
          ecdaRegistrationChildParents {
            data {
              fkRelationship
            }
          }
        }
        centre {
          code
          label
          email
          addresses {
            data {
              address
              mobilePhone
              postcode
            }
          }
        }
        level {
          label
        }
        program {
          label
        }
      }
    }
  }
`;

export const CANCEL_ECDA_REGISTRATION = gql`
  mutation cancelECDARegistration(
    $registrationID: Int!
    $isReapplication: Boolean!
    $remarks: String
    $cancellationReason: Int!
    $bypassExceeding: Boolean
  ) {
    cancelECDARegistration(
      IDECDARegistration: $registrationID
      isReapplication: $isReapplication
      remarks: $remarks
      IDCancellationReason: $cancellationReason
      BypassExceeding: $bypassExceeding
    ) {
      ID
    }
  }
`;

export const REINSTATE_CANCELLED_ECDA_REGISTRATION = gql`
  mutation reinstateCancelledECDARegistration(
    $registrationID: Int!
    $remarks: String
  ) {
    reinstateCancelledECDARegistration(
      IDRegistration: $registrationID
      remarks: $remarks
    )
  }
`;

export const MERGE_ECDA_REGISTRATION_PARENT_EMAIL = gql`
  mutation mergerECDARegistrationParentEmail(
    $notSelectedEmail: String!
    $selectedEmail: String!
  ) {
    mergerECDARegistrationParentEmail(
      notSelectedEmail: $notSelectedEmail
      selectedEmail: $selectedEmail
    )
  }
`;
